import React, { forwardRef } from 'react';
import { CalendarIcon } from '@chakra-ui/icons';
import { Input, InputGroup, InputRightElement } from '@chakra-ui/react';
import ReactDatePicker from 'react-datepicker';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const CalendarText = styled.p.attrs({
  className: 'awt-calendar-text',
})`
  background-color: black;
  color: white;
  padding: 10px;
  border-radius: 3px;
  margin-top: auto;
`;

interface IProps {
  placeholderText: string;
  value: Date;
  onChange: (date: Date) => void;
  minDate: Date;
  isInvalid?: boolean;
  required?: boolean;
  timezone?: string;
  filterDate?: (date: Date) => boolean;
}

export const DatePicker = ({
  timezone,
  placeholderText,
  value,
  onChange,
  minDate,
  isInvalid,
  filterDate,
  required,
}: IProps): React.ReactElement => {
  const { t } = useTranslation();

  const DatePickerInput = forwardRef(
    ({ value, onClick, onChange }: any, ref) => (
      <InputGroup onClick={onClick}>
        <Input
          aria-label={t('tables.next_order')}
          placeholder={value}
          value={value}
          onChange={onChange}
          isInvalid={isInvalid}
          required={required}
          data-testid="awt-date-picker-input"
        />
        <InputRightElement>
          <CalendarIcon />
        </InputRightElement>
      </InputGroup>
    ),
  );

  const CalendarContainer = ({ children, ...props }) => (
    <>
      <div {...props}>{children}</div>
      <CalendarText>
        {t('calendar.timezone_message', {
          timezone,
        })}
      </CalendarText>
    </>
  );
  return (
    <ReactDatePicker
      data-testid="awt-date-picker"
      placeholderText={placeholderText}
      selected={value}
      minDate={minDate}
      onChange={onChange}
      filterDate={filterDate}
      customInput={<DatePickerInput />}
      calendarContainer={timezone && CalendarContainer}
    />
  );
};
